/* ─────────────────────────────────────────────────────────────────────────
   KIMDYMA · eb-faq.js — the stage pills and the search box. v4.0

   Hand-written, and ADDITIVE in the strictest sense: with this file blocked
   every question is present and open, and the browser's own find works across
   all of them. That is the right failure for a page whose entire job is to be
   searched — a filter that is the only way to reach an answer is a filter
   that hides answers.

   TWO CONTROLS OVER ONE LIST, and they compose: a stage narrows the list and
   the text box narrows what is left. A stage whose every question has just
   gone takes its heading with it, because a heading over nothing reads as a
   section that failed to load.

   A QUESTION THAT MATCHES A SEARCH OPENS ITSELF. Making somebody type a word,
   see the question, and then press it to read the answer is charging them
   twice for the same intent.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  if (window.ebFaqLoaded) return;
  window.ebFaqLoaded = true;

  var slice = function (l) { return Array.prototype.slice.call(l); };

  function faq(list) {
    if (list.dataset.faqBound) return;
    list.dataset.faqBound = '1';

    /* The CONTROLS sit in the head and the LIST in the band under it, so the
       controls are looked up on the section and only the items on the list. */
    var section = list.closest('.eb-section') || document;
    var pills = slice(section.querySelectorAll('[data-faq-stage]'));
    var input = section.querySelector('[data-faq-search]');
    var count = section.querySelector('[data-faq-count]');
    var items = slice(list.querySelectorAll('.eb-accordion__item'));
    var groups = slice(list.querySelectorAll('[data-faq-group]'));
    var empty = list.querySelector('[data-faq-empty]');
    if (!items.length) return;

    var stage = 'all';

    function apply() {
      var q = ((input && input.value) || '').trim().toLowerCase();
      var n = 0;

      items.forEach(function (it) {
        var group = it.closest('[data-faq-group]');
        var inStage = stage === 'all' || (group && group.getAttribute('data-faq-group') === stage);
        var hit = !q || it.textContent.toLowerCase().indexOf(q) > -1;
        var on = inStage && hit;
        it.hidden = !on;
        if (on) n++;
        if (q && on) {
          it.classList.add('is-open');
          var trigger = it.querySelector('.eb-accordion__trigger');
          if (trigger) trigger.setAttribute('aria-expanded', 'true');
        }
      });

      groups.forEach(function (g) {
        g.hidden = !items.some(function (it) {
          return !it.hidden && it.closest('[data-faq-group]') === g;
        });
      });

      if (count) count.textContent = n;
      if (empty) empty.hidden = n > 0;
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        stage = p.getAttribute('data-faq-stage');
        pills.forEach(function (x) {
          x.setAttribute('aria-pressed', x === p ? 'true' : 'false');
        });
        apply();
      });
    });
    if (input) input.addEventListener('input', apply);
    apply();
  }

  function bind(scope) {
    slice((scope || document).querySelectorAll('[data-eb-faq]')).forEach(faq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else { bind(document); }
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
